<template>
  <div>
    <div class="foodDetail_banner">
      <div class="foodDetail_bannerDetail">
        <img :src="storeDeatil.thumb" class="foodDetail_img" />
        <div class="foodDetail_text">{{storeDeatil.name}}</div>
      </div>
    </div>
    <div v-for="(item,index) in productItem">
      <div class="foodDetail_center_text">{{item.name}}</div>
      <div class="foodDetail_quan_List1">
        <div :class="item1.id===id? 'video_detail_chongzhibox1' :'video_detail_chongzhibox' " v-for="(item1,index1) in item.productItem"
          @click="selectnum(index1,index)">
          <div class="video_detail_price">{{item1.name}}</div>
          <div class="video_detail_kind">{{item1.price}}</div>
        </div>
      </div>
    </div>
    <!--    <div class="shoppingdetail_zhanghao">
      <div class="shoppingDetail_center_text">填写账号</div>
      <van-cell-group>
        <van-field v-model="phonenum" placeholder="请输入手机号码充值" />
      </van-cell-group>
    </div> -->
    <div class="shoppingdetail_bangding" v-if="price!=''" @click="toRecharge()">
      <div class="shoppingdetail_bangding_car">立即支付({{price}}积分)</div>
    </div>
    <div class="shoppingdetail_bangding" v-else>
      <div class="shoppingdetail_bangding_car">立即充值</div>
    </div>
    <div class="shoppingdetail_shuoming" v-if="storeDeatil.detail">
      <div class="shoppingdetail_tip_title">充值说明</div>
      <div class="shoppingdetail_tip">{{storeDeatil.detail}}</div>
    </div>
  </div>
  <!--    <div class="foodDetail_center_text">购买代金券</div>
    <div class="foodDetail_quan_List1 ">
      <div :class="item.shopSelect ? 'foodDetail_quan_box1' : 'foodDetail_quan_box'"
        v-for="(item,index) in foodDetail.foodDetailbox" @click="changegangbeng(index)">
        <div>{{item.price}}元</div>
        <div>代金券</div>
      </div>
      <div class="foodDetail_buybutton">立即购买</div>
    </div> -->
  <!--    <img src="/static/quse1.png" /> -->
  </div>
</template>

<script>
  import axios from 'axios'
  import httper from '../../api/http';
  import {
    Dialog
  } from 'vant';
  export default {
    data() {
      return {
        amount: "", //用户所有积分数
        listDetail: {}, //上个页面传来的会员详情
        storeDeatil: {}, //接口获取商品详情
        productItem: [], //商品套餐分类列表
        productItemDetail: [], //商品套餐详情
        phonenum: "", //手机充值账号
        price: "", //应付金额
        buttonClicked: false, // 防止支付重复点击,默认为false
        packageValue: 0, //套餐标识
        proindex: "", //套餐类型标识
        source_desc: "", //充值说明
        id: "", //套餐详情id
      }
    },
    created() {
      // if (this.$route.query.foodDetailId != 'undefined') {
      //   this.foodDetailId = this.$route.query.foodDetailId
      //   let that = this
      //   that.foodDetail = that.foodDetailList[Number(that.foodDetailId)]
      // }
      if (this.$route.query.id != 'nudefined') {
        this.request("getProductDetail", {
          id: this.$route.query.id
        })
      }
      this.request('getUserInfo')
    },
    mounted() {

    },
    methods: {
      changegangbeng(e) {
        let that = this
        let foodDetail = that.foodDetail
        foodDetail.foodDetailbox.map((item, index) => item.shopSelect = index === Number(e))
      },
      //改变选择的套餐
      selectnum(e, proindex) {
        let that = this
        //获取套餐详情id
        that.id = that.productItem[Number(proindex)].productItem[Number(e)].id
        //that.productItem[Number(proindex)].productItem.map((item1, index1) => item1.packageChecked = index1===Number(e))
        //获取套餐详情价格
        that.price = that.productItem[Number(proindex)].productItem[Number(e)].price
        //获取套餐详情说明
        that.source_desc = that.productItem[Number(proindex)].productItem[Number(e)].source_desc
        //获取套餐类型标识
        that.proindex = Number(proindex)
        //获取套餐详情标识
        that.packageValue = Number(e)
      },
      /**
       * 防重点击
       * @param duration
       * @returns {Promise<any>}
       */
      buttonClickedFun(duration = 0) {
        this.buttonClicked = true
        return new Promise((resolve, reject) => {
          if (duration && typeof duration === 'number') {
            setTimeout(() => {
              this.buttonClicked = false
            }, duration)
          }
          resolve(true)
        })
      },
      //支付
      toRecharge() {
        var order_param = {} //下单参数
        var that = this
        this.buttonClickedFun(1000) // 防止重复点击
        // 手机号码格式错误时顶部显示错误提示2秒
        // !/^1[2-9][0-9]{9}$/.test(Number(that.phonenum.toString().substring(0, 11)))
        // if (!(/^1[3456789]\d{9}$/.test(Number(that.phonenum)))) {
        //   this.$swal({
        //     text: '手机号格式错误'
        //   })
        //   return
        // }
        var product = that.storeDeatil
        var productItem = that.productItem[that.proindex].productItem[that.packageValue]
        console.log("productItem", productItem)

        order_param.amount = productItem.price
        order_param.type = 'online'
        order_param.product_type = 3
        order_param.product_item_id = productItem.id
        order_param.recharge_number = 0
        console.log("that.amount > productItem.price", that.amount > productItem.price)
        // 判断用户是微信支付还是余额支付
        if (parseFloat(that.amount) < parseFloat(productItem.price)) {
          // this.$swal({
          //   title: '提示',
          //   text: "积分不足，前往充值？",
          //   buttons: ['取消', '确认'],
          //   type: "warning",
          //   showCancelButton: true,
          // }).then((confirm) => {
          //   console.log("confirm", confirm)
          //   if (confirm.value) {
          //     that.$router.push({
          //       path: "/account"
          //     })
          //   } else {
          //     return false;
          //   }
          // })
          // this.$messagebox.confirm('', {
          //   title: "提示",
          //   message: "积分不足，前往充值？",
          //   confirmButtonText: '确认',
          //   cancelButtonText: '取消'
          // }).then(action => {
          //   console.log(action)
          //   if (action == 'confirm') {
          //     that.$router.push({
          //       path: "/account"
          //     })
          //   }
          // }).catch(error => {
          //   if (error == 'cancel') {
          //     return false;
          //   }
          // })
          Dialog.confirm({
              title: '提示',
              message: '积分不足，前往充值？',
            })
            .then(() => {
              that.$router.push({
                path: "/account"
              })
            })
            .catch(() => {
              return false;
            });
        } else {
          Dialog.confirm({
              title: '提示',
              message: '是否用余额支付?',
            })
            .then(() => {
              order_param.pay_type = 'balance'
              that.request('YeunifiedOrder', order_param)
            })
            .catch(() => {
              return false;
            });
          // this.$swal({
          //   title: '提示',
          //   text: "是否用余额支付？",
          //   buttons: ['取消', '确认'],
          //   type: "warning",
          //   showCancelButton: true,
          // }).then((confirm) => {
          //   if (confirm.value) {
          //     order_param.pay_type = 'balance'
          //     that.request('YeunifiedOrder', order_param)
          //   } else {
          //     return false;
          //   }
          // })
          // this.$messagebox.confirm('', {
          //   title: "提示",
          //   message: "是否用余额支付?",
          //   confirmButtonText: '确认',
          //   cancelButtonText: '取消'
          // }).then(action => {
          //   console.log(action)
          //   if (action == 'confirm') {
          //     order_param.pay_type = 'balance'
          //     that.request('YeunifiedOrder', order_param)
          //   }
          // }).catch(error => {
          //   if (error == 'cancel') {
          //     return false;
          //   }
          // })
        }
      },
      // 调用接口封装
      request(type = '', requestData = {}) {
        let that = this
        switch (type) {
          //获取个人信息余额
          case 'getUserInfo':
            //获取个人信息余额
            httper.get('/wechat/user/info', requestData, res => {
              if (res.code === 0) {
                var amount1 = res.data.account.amount.toFixed(2)
                that.amount = amount1
                console.log('amount1', amount1)
              } else {
                this.$toast({
                  message: res.data.message || '系统异常',
                })
              }
            }, true)
            break
            //获取商品详情
          case 'getProductDetail':
            httper.get('/product/detail', requestData, res => {
              if (res.code === 0) {
                console.log("商品详情", res)
                this.storeDeatil = res.data
                this.productItem = this.storeDeatil.productItem
                // for(let i in this.productItem){
                //   this.productItemDetail = this.productItem[i]
                //   console.log("this.productItemDetail",this.productItemDetail)
                // }
              } else {
                this.$toast({
                  message: res.data.message || '系统异常',
                })
              }
            }, true)
            break
            //余额支付
          case 'YeunifiedOrder':
            httper.post('/payment/unified-order', requestData, res => {
              if (res.code === 0) {
                // wx.navigateTo({
                //   url: '/pages/order/detail?id=' + res.data.order_no
                // })
                this.$router.push({
                  path: "orderListDetail",
                  query: {
                    id: res.data.order_no
                  }
                })
              } else {
                // wx.showToast({
                //   title: res.data.message || '系统异常',
                //   icon: 'none'
                // })
                this.$toast({
                  message: res.data.message || '系统异常',
                })
              }
            }, true)
            break
        }
      },
    }
  }
</script>

<style>
  .foodDetail_quan_List {
    margin: 20px;
  }

  .foodDetail_quan_List1 {
    margin: 20px;
    display: flex;
    flex-wrap: wrap;
    /*    justify-content: space-between; */
  }

  /*
  .foodDetail_quan_box {
    display: flex;
    margin: 20px 0;
    border: 3px solid #FFFFFF;
  }

  .foodDetail_quan_box1 {
    display: flex;
    margin: 20px 0;
    border: 3px solid #EE9D27;
  } */

  .foodDetail_box_left {
    width: 40%;
    height: 90px;
  }

  .foodDetail_box_left_img {
    width: 100%;
    height: 100%;
  }

  .foodDetail_box_right {
    width: 60%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background-color: aliceblue;
  }

  .foodDetail_right_top {
    display: flex;
    width: 170px;
  }

  .foodDetail_rightl {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 50px;
    margin: 5px;
  }

  .foodDetail_daijin {}

  .foodDetail_fenjie {
    border-bottom: 1px dashed #9d9797;
    width: 40px;
    margin-top: 5px;
  }

  .foodDetail_rmb {}

  .foodDetail_rightc {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-left: 5px;
    font-size: 40px;
    width: 70px;
  }

  .foodDetail_rightr {
    display: flex;
    justify-content: center;
    align-items: flex-end;
    margin-left: 20px;
    margin-bottom: 10px;
  }

  .foodDetail_right_bottom {
    border: 1px dashed #9d9797;
    width: 170px;
  }

  .foodDetail_buybutton {
    margin: 20px 50px;
    height: 50px;
    width: 75%;
    border-radius: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #58b4c1;
    color: #FFFFFF;
  }

  .foodDetail_banner {
    width: 90%;
    height: 160px;
    /*    background-color: #583e36; */
    /*   background: -webkit-linear-gradient(bottom, hsl(202, 37%, 90%), hsl(226, 100%, 84%), #3b6bfb) no-repeat;
 */
    margin: 20px;
    background-color: #FCDDD8;
  }

  .foodDetail_bannerDetail {
    /*    margin-left: 20px; */
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
  }

  .foodDetail_img {
    width: 70px;
    height: 70px;
    border-radius: 35px;
    margin-bottom: 20px;
  }

  .foodDetail_text {
    color: #000;
    font-size: 22px;
  }

  .foodDetail_lipin_box {
    background-image: url(../../../static/lipinka.png);
    background-size: cover;
    width: 120px;
    height: 120px;
    border-radius: 60px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    font-size: 20px;
    margin: 10px 0;
    color: #525151;
  }

  .foodDetail_lipin_box1 {
    background-image: url(../../../static/lipinka111.png);
    background-size: cover;
    width: 120px;
    height: 120px;
    border-radius: 60px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    font-size: 20px;
    margin: 10px 0;
    color: #000;
  }

  .foodDetail_quan_box {
    background-image: url(../../../static/quan.png);
    background-size: cover;
    width: 118px;
    height: 120px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    font-size: 20px;
    margin: 10px 3px;
    color: #525151;
  }

  .foodDetail_quan_box1 {
    background-image: url(../../../static/quan1.png);
    background-size: cover;
    width: 118px;
    height: 120px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    font-size: 20px;
    margin: 10px 3px;
    color: #f0aa64;
    /*   color: #FFFFFF; */
  }

  .video_detail_chongzhibox {
    height: 80px;
    border: 1px solid #dedede;
    padding: 20px 0;
    margin: 10px;
    width: 25%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;
  }

  .video_detail_chongzhibox1 {
    height: 80px;
    border: 1px solid #F0533E;
    padding: 20px 0;
    margin: 10px;
    width: 100px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    color: #F0533E;
    text-align: center;
  }

  .foodDetail_center_text {
    margin: 20px;
    font-size: 20px;
  }

  .shoppingDetail_center_text {
    margin: 20px;
    font-size: 20px;
  }

  .shoppingdetail_title {
    margin: 20px 0;
    font-weight: bold;
  }


  .shoppingdetail_bangding {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 30px;
  }

  .shoppingdetail_bangding_car {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 280px;
    height: 50px;
    background-color: #F0533E;
    color: #ffffff;
    border-radius: 25px;
    /*  margin-top: 70px ; */
  }

  .shoppingdetail_shuoming {
    margin: 10px;
    /* background-color: #e6e6e6; */
    border: 1px solid #e6e6e6;
    display: flex;
    flex-direction: column;
    /*    align-items: center;
     justify-content: flex-start; */
    padding: 20px 25px;
    font-size: 15px;
  }

  .shoppingdetail_tip_title {
    margin: 20px 0;
    text-align: center;
  }

  .shoppingdetail_tip {
    display: flex;
    justify-content: flex-start;
  }

  .shoppingdetail_tip1 {
    margin: 5px;
    color: #ff9940;
  }
</style>



// WEBPACK FOOTER //
// src/pages/food/foodDetail.vue